import * as React from 'react';
import b_ from 'b_';
import { Trans } from 'react-i18next';

import './index.scss';

const b = b_.with('main-page-benefits');

export default () => (
  <div className={b()} data-testid="main-page-benefits">
    <div className={b('item')} data-testid={'benefit-select-idea'}>
      <div>
        <Trans i18nKey="Select an idea Experts have found the best ones">
          Select an idea. Experts
          <br />
          have found the best ones
        </Trans>
      </div>
    </div>
    <div className={b('item')} data-testid={'benefit-try-it'}>
      <div>
        <Trans i18nKey="Try it out with $10">
          Try it out
          <br />
          with $10
        </Trans>
      </div>
    </div>
    <div className={b('item')} data-testid={'benefit-build-portfolio'}>
      <div>
        <Trans i18nKey="Build a portfolio from shares">
          Build a portfolio
          <br />
          from shares
        </Trans>
      </div>
    </div>
    <div className={b('item')} data-testid={'benefit-make-profit'}>
      <div>
        <Trans i18nKey="Make a profit of 20-80% per year">
          Make a profit
          <br />
          of 20-80% per year
        </Trans>
      </div>
    </div>
  </div>
);
